import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'

/**
 * Shared MUI Form wrapper component
 * Replaces muicss Form pattern
 *
 * This component provides a form container that can be used as a drop-in replacement
 * for muicss Form components. It uses Material-UI's Box component for layout
 * and can handle form submission events.
 */
export default function MuiForm ({
  children,
  className,
  onSubmit,
  component = 'form',
  ...otherProps
}) {
  const handleSubmit = (event) => {
    if (onSubmit) {
      event.preventDefault()
      onSubmit(event)
    }
  }

  return (
    <Box component={component} className={className} onSubmit={handleSubmit} {...otherProps}>
      {children}
    </Box>
  )
}

MuiForm.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onSubmit: PropTypes.func,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
}

MuiForm.defaultProps = {
  component: 'form',
}
